import type { LocaleDictionary } from "@/i18n/types";

const nsUploadJA = {
  dragAndDrop: {
    selectFile: "ファイルを選択",
    /** ＆ は Figma に合わせた全角。 */
    prompt: "またはここにドラッグ＆ドロップ",
    /** 「Excelデータは1件まで」のような1種類分の断片。limitSeparator で連結して limitNote に渡す。 */
    limitItem: ({
      typeName,
      limit,
      hasMultipleTypes,
    }: {
      typeName: string;
      limit: number;
      hasMultipleTypes: boolean;
    }) => `${typeName}${hasMultipleTypes ? "は" : "を"}${limit}件まで`,
    limitSeparator: "、",
    limitNote: ({ fileLimits }: { fileLimits: string }) =>
      `(${fileLimits}アップロード可能)`,
  },
  fileType: {
    excel: "Excelデータ",
    csv: "CSVデータ",
    json: "JSONデータ",
    yaml: "YAMLデータ",
    zip: "ZIPデータ",
  },
  dataName: "データ名",
  deleteButton: "削除",
} satisfies LocaleDictionary;

export default nsUploadJA;
